document.addEventListener('DOMContentLoaded', function () {

    // BURGER
    // Открытое меню — модальное состояние страницы: затемняем фон, блокируем
    // прокрутку и убираем всё остальное, что висит поверх (панель CTA, поп-ап).
    var burger = document.getElementById('landingBurger');
    var menu = document.getElementById('landingMobileMenu');
    var header = document.querySelector('.landing-header');
    var menuOpen = false;

    function setMenu(open) {
        if (!burger || !menu) return;

        menuOpen = open;
        menu.classList.toggle('is-open', open);
        burger.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('is-menu-open', open);
        document.documentElement.classList.toggle('is-menu-open', open);

        if (open) {
            var popup = document.querySelector('.cta-popup');
            if (popup) popup.classList.remove('active');
            document.body.classList.remove('is-cta-open');
        }
    }

    if (burger && menu) {
        burger.addEventListener('click', function () {
            setMenu(!menuOpen);
        });

        menu.querySelectorAll('a').forEach(function (link) {
            link.addEventListener('click', function () {
                setMenu(false);
            });
        });

        // Клик по затемнению (псевдоэлемент body) и Esc закрывают меню
        document.addEventListener('click', function (e) {
            if (menuOpen && header && !header.contains(e.target)) setMenu(false);
        });

        document.addEventListener('keydown', function (e) {
            if (menuOpen && e.key === 'Escape') setMenu(false);
        });

        window.addEventListener('resize', function () {
            if (menuOpen && window.innerWidth > 1040) setMenu(false);
        }, { passive: true });
    }

    // ГОРИЗОНТАЛЬНЫЕ РЯДЫ
    // Стрелки показываются только если ряду действительно есть куда скроллиться.
    document.querySelectorAll('[data-scroll-row]').forEach(function (row) {
        var controls = document.querySelector('[data-scroll-controls="' + row.id + '"]');
        if (!controls) return;

        var arrows = controls.querySelectorAll('.landing-scroll-arrow');

        function overflow() {
            return row.scrollWidth - row.clientWidth;
        }

        function sync() {
            var max = overflow();

            controls.classList.toggle('is-hidden', max < 8);
            if (max < 8) return;

            arrows.forEach(function (arrow) {
                var dir = parseInt(arrow.getAttribute('data-dir'), 10) || 1;
                var atStart = row.scrollLeft <= 2;
                var atEnd = row.scrollLeft >= max - 2;
                arrow.disabled = dir < 0 ? atStart : atEnd;
            });
        }

        arrows.forEach(function (arrow) {
            arrow.addEventListener('click', function () {
                var card = row.querySelector(':scope > *');
                var gap = parseFloat(getComputedStyle(row).columnGap) || 18;
                var step = card ? card.getBoundingClientRect().width + gap : 260;
                var dir = parseInt(arrow.getAttribute('data-dir'), 10) || 1;

                row.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
            });
        });

        row.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync, { passive: true });

        if ('ResizeObserver' in window) {
            new ResizeObserver(sync).observe(row);
        }

        sync();
    });

    // PHOTO SLIDERS IN "HOW IT WORKS"
    /**
     * Turn one [data-howit-slider] block into a slider: arrows, dots, swipe.
     *
     * @param {HTMLElement} slider Slider root element.
     * @return {void}
     */
    function initHowitSlider(slider) {
        var track = slider.querySelector('.landing-howit__track');
        var slides = slider.querySelectorAll('.landing-howit__slide');
        var arrows = slider.querySelectorAll('.landing-howit__arrow');
        var dotsBox = slider.querySelector('[data-howit-dots]');
        var index = 0;

        if (!track || slides.length < 2) return;

        var dots = [];

        if (dotsBox) {
            slides.forEach(function (slide, i) {
                var dot = document.createElement('button');

                dot.type = 'button';
                dot.className = 'landing-howit__dot';
                dot.setAttribute('aria-label', String(i + 1));
                dot.addEventListener('click', function () { go(i); });
                dotsBox.appendChild(dot);
                dots.push(dot);
            });
        }

        /**
         * Move the track to a slide and refresh arrow/dot state.
         *
         * @param {number} next Target slide index (clamped to the range).
         * @return {void}
         */
        function go(next) {
            index = Math.max(0, Math.min(next, slides.length - 1));
            track.style.transform = 'translateX(' + (-index * 100) + '%)';

            arrows.forEach(function (arrow) {
                var dir = parseInt(arrow.getAttribute('data-howit-dir'), 10) || 1;
                arrow.disabled = dir < 0 ? index === 0 : index === slides.length - 1;
            });

            dots.forEach(function (dot, i) {
                dot.classList.toggle('is-active', i === index);
            });
        }

        arrows.forEach(function (arrow) {
            arrow.addEventListener('click', function () {
                go(index + (parseInt(arrow.getAttribute('data-howit-dir'), 10) || 1));
            });
        });

        // Swipe: horizontal drag over 40px switches the slide and cancels the lightbox click.
        var startX = 0;
        var startY = 0;
        var swiped = false;

        track.addEventListener('touchstart', function (e) {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            swiped = false;
        }, { passive: true });

        track.addEventListener('touchmove', function (e) {
            var dx = e.touches[0].clientX - startX;
            var dy = e.touches[0].clientY - startY;

            if (swiped || Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;

            swiped = true;
            go(index + (dx < 0 ? 1 : -1));
        }, { passive: true });

        // Capture phase: stops GLightbox from opening on the link the swipe ended over.
        track.addEventListener('click', function (e) {
            if (!swiped) return;
            e.preventDefault();
            e.stopPropagation();
        }, true);

        go(0);
    }

    document.querySelectorAll('[data-howit-slider]').forEach(initHowitSlider);

    // TEACHER BIOS
    /**
     * Collapse a long teacher bio behind a "more" button; a short bio stays open.
     *
     * @param {HTMLElement} bio Bio element marked with [data-teacher-bio].
     * @return {void}
     */
    function initTeacherBio(bio) {
        var button = bio.nextElementSibling;
        if (!button || !button.hasAttribute('data-teacher-more')) return;

        var moreLabel = button.textContent;
        var lessLabel = button.getAttribute('data-less') || moreLabel;
        var open = false;

        /**
         * Show the button only while the collapsed text actually overflows.
         *
         * @return {void}
         */
        function sync() {
            if (open) return;

            bio.classList.remove('landing-teacher__bio--full');
            var fits = bio.scrollHeight <= bio.clientHeight + 4;
            bio.classList.toggle('landing-teacher__bio--full', fits);
            button.hidden = fits;
        }

        button.addEventListener('click', function () {
            open = !open;
            bio.classList.toggle('landing-teacher__bio--full', open);
            button.setAttribute('aria-expanded', open ? 'true' : 'false');
            button.textContent = open ? lessLabel : moreLabel;

            if (!open) {
                sync();
                bio.closest('.landing-teacher').scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            }
        });

        window.addEventListener('resize', sync, { passive: true });
        sync();
    }

    document.querySelectorAll('[data-teacher-bio]').forEach(initTeacherBio);

    // ВИДЕО В БАННЕРЕ
    // При включённом «уменьшении движения» останавливаем ролик — остаётся постер.
    var bannerVideo = document.querySelector('.landing-banner__video');

    if (bannerVideo && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        bannerVideo.removeAttribute('autoplay');
        bannerVideo.pause();
    }

    // НИЖНЯЯ ПАНЕЛЬ
    // Пока виден первый экран, у него есть своя кнопка — панель была бы
    // третьим одинаковым CTA в одном кадре. Показываем её после баннера.
    var banner = document.querySelector('.landing-banner');

    if (banner) {
        if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (entries) {
                document.body.classList.toggle('is-past-hero', !entries[0].isIntersecting);
            }, { rootMargin: '-40% 0px 0px 0px' }).observe(banner);
        } else {
            document.body.classList.add('is-past-hero');
        }
    } else {
        document.body.classList.add('is-past-hero');
    }

    // BACK TO TOP
    var backTop = document.getElementById('landingBackTop');

    if (backTop) {
        window.addEventListener('scroll', function () {
            backTop.classList.toggle('is-visible', window.scrollY > 600);
        }, { passive: true });
    }

    // АНИМАЦИИ ПРИ ПРОКРУТКЕ
    // Каждый элемент с data-anim получает вариант появления; соседи внутри
    // одного контейнера идут каскадом через --reveal-i.
    var animated = document.querySelectorAll('[data-anim]');

    if (animated.length) {
        var motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!motionOk || !('IntersectionObserver' in window)) {
            animated.forEach(function (el) { el.classList.add('is-in'); });
        } else {
            var groups = new Map();

            animated.forEach(function (el) {
                el.classList.add('landing-reveal', 'landing-reveal--' + (el.getAttribute('data-anim') || 'up'));

                var parent = el.parentElement;
                var index = groups.get(parent) || 0;
                groups.set(parent, index + 1);
                el.style.setProperty('--reveal-i', Math.min(index, 6));
            });

            var io = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-in');
                        io.unobserve(entry.target);
                    }
                });
            }, { threshold: .1, rootMargin: '0px 0px -8% 0px' });

            animated.forEach(function (el) { io.observe(el); });
        }
    }

    // GLIGHTBOX
    // Plyr takes one aspect ratio per lightbox, so Shorts links
    // (data-vertical-video) get their own instance with a 9:16 player.
    if (typeof GLightbox !== 'undefined' && document.querySelector('.glightbox')) {
        GLightbox({
            selector: '.glightbox:not([data-vertical-video])',
            touchNavigation: true,
            loop: true
        });

        if (document.querySelector('.glightbox[data-vertical-video]')) {
            GLightbox({
                selector: '.glightbox[data-vertical-video]',
                touchNavigation: true,
                loop: true,
                plyr: { config: { ratio: '9:16' } }
            });
        }
    }

    // ИНДИКАТОР ОТПРАВКИ ФОРМ
    // Родной спиннер CF7 — серый кружок под формой. Оборачиваем кнопку, чтобы
    // показать загрузку прямо в ней (сама анимация — в _submit.scss).
    document.querySelectorAll('.wpcf7-form input[type="submit"]').forEach(function (submit) {
        if (submit.parentNode.classList.contains('landing-submit')) return;

        var wrap = document.createElement('span');
        wrap.className = 'landing-submit';
        submit.parentNode.insertBefore(wrap, submit);
        wrap.appendChild(submit);
    });

    // CTA POPUP
    var ctaPopup = document.querySelector('.cta-popup');

    if (ctaPopup) {
        var ctaHeader = ctaPopup.querySelector('.cta-popup__header');

        // Класс на body нужен стилям: пока поп-ап раскрыт, нижняя панель прячется
        function setPopup(open) {
            ctaPopup.classList.toggle('active', open);
            document.body.classList.toggle('is-cta-open', open);
        }

        if (ctaHeader) {
            ctaHeader.addEventListener('click', function () {
                setPopup(!ctaPopup.classList.contains('active'));
            });
        }

        setTimeout(function () {
            if (menuOpen) return;
            setPopup(true);
            var audio = new Audio('/wp-content/themes/solovey/assets/dist/img/solovey_sound.mp3');
            audio.play().catch(function () {});
        }, parseInt(ctaPopup.getAttribute('data-time'), 10) || 0);
    }

});
